export const capitalizeWord = (word) => {
  if (typeof word !== "string") return "";
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export const capitalizeEachWord = (str) => {
  return str
    .split(' ')
    .map(word =>
      word?.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(' ');
}